<template>
  <div>
      <v-layout wrap row justify-start pa-2 py-5>
        <v-flex xs6 px-2>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Warehouse
						</v-card-title>
            <v-card-actions v-if="false">
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" persistent max-width="290">
                <v-btn color="primary" dark slot="activator">add a warehouse</v-btn>
                <v-card>
                  <v-card-title class="headline">New Warehouse</v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-select
                          :items="countries"
                          solo
                          v-model="nwarehouse.country"
                          label="Country"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          label="Name"
                          solo
                          v-model="nwarehouse.name"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" flat @click="dialog=false">close</v-btn>
                    <v-btn @click="warehouseAdd()" :loading="loading" color="success" dark>
                      add warehouse
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogImport" persistent max-width="700">
                <v-btn color="primary" class="ml-2" dark slot="activator" v-if="superAdmin">Import to Warehouses</v-btn>
                <v-card>
                  <v-card-title class="headline">Import Products</v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 md12 pa-1>
                        <v-textarea
                          label="Keys OR Document Numbers"
                          v-model="pastedData"
                          solo
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs12 class="title text-xs-center">
                        {{importDone}} / {{importTotal}}
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" flat @click.native="dialogImport = false">Cancel</v-btn>
                    <v-btn color="primary" @click.native="importWarehouses()">Import</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-actions>
            <v-card-text>
              <v-layout row wrap>
                {{warehouse}}
                <v-flex xs12>
                  <v-select
                    :items="warehouses.filter(x=>{
                      if(x.name==warehouse) {
                        return x
                      }
                    })"
                    solo
                    :disabled="loading || syncing"
                    :loading="loading"
                    return-object
                    v-model="selectedWarehouse"
                    label="Warehouse"
                    @change="loadWarehouseProducts"
                    item-text="name"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" :disabled="!selectedWarehouse" @click="exportWarehouseh()">Export warehouse</v-btn>
            </v-card-actions>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 v-if="selectedWarehouse">
                  <v-layout row wrap style="height:600px;overflow-y:scroll;">
                    <v-flex xs12 px-1>
                      <v-layout row wrap>
                        <v-flex xs3 style="font-weight:bold;">
                          Name
                        </v-flex>
                        <v-flex xs3 style="font-weight:bold;">
                          SKU
                        </v-flex>
                        <v-flex xs3 style="font-weight:bold;">
                          Quantity
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 v-for="(product, i) in selectedWarehouse.products" :key="'warehouseProducts'+i" px-1>
                      <v-card class="pa-2">
                        <v-layout row wrap>
                          <v-flex xs4>
                            {{product.item_name}} 
                          </v-flex>
                          <v-flex xs4>
                            {{product.sku}}
                          </v-flex>
                          <v-flex xs4>
                            {{product.warehouses.filter(x=>x.warehouse==selectedWarehouse.name)[0].quantity}}
                          </v-flex>
                          <v-flex xs3 v-if="false">
                            <v-btn color="success" flat small @click="selectedProduct = products.filter(x=>x.key == product.key)[0]">edit</v-btn>
                          </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs6 px-2 v-if="false">
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Products
						</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- <v-dialog v-model="dialogAdd" persistent max-width="290">
                <v-card>
                  <v-card-title class="headline">Add a new Product?</v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          label="Product Name"
                          required
                          v-model="nName"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          label="Product SKU"
                          required
                          v-model="nSKU"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" flat @click="dialogAdd = false">Cancel</v-btn>
                    <v-btn :disabled="!nName || !nSKU" color="primary" flat @click="addProduct()">add</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog> -->
              <!-- <v-btn color="primary" @click="dialogAdd = true" :loading="syncing" :disabled="syncing">add Product</v-btn> -->
              <!-- <v-btn color="primary" @click="syncProducts()" :loading="syncing" :disabled="syncing">Sync Products</v-btn> -->
            </v-card-actions>
            <v-card-text>
              <v-layout row wrap>
								<v-flex xs12 md12 pa-1>
									<v-autocomplete
                    label="Products"
                    :items="products"
                    v-model="selectedProduct"
                    item-text="item_name"
                    return-object
                    :disabled="loading || syncing"
                    :loading="loading"
                    solo
                  ></v-autocomplete>
              	</v-flex>                
              </v-layout>
              <v-layout row wrap v-if="selectedProduct">
								<v-flex v-for="(warehouse, k) in selectedProduct.warehouses" :key="k" xs12>
									<v-card>
										<v-layout row wrap align-center pa-4>
											<v-flex xs6 px-1>
												Warehouse
												<v-autocomplete
													:items="warehouses"
													v-model="selectedProduct.warehouses[k].warehouse"
													label="Select a warehouse"
													solo
													clearable
                          item-value="name"
                          item-text="name"
													hide-details
													:loading="loading"
													:append-outer-icon="`${(( userRole == 'admin') ? 'add' : '')}`"
													@click:append-outer="dialog = true"
												></v-autocomplete>
											</v-flex>
											<v-flex xs4 px-1>
												Quantity
												<v-text-field
													v-model="selectedProduct.warehouses[k].quantity"
													hide-details
													@keypress="isNumber($event)"
													solo
												></v-text-field>
											</v-flex>
											<v-flex v-if="superAdmin" xs1 class="text-xs-center">
												<v-btn @click="removeWearhouse(k)" color="error" icon flat dark px-2>
													<v-icon size="16px">close</v-icon>
												</v-btn>
											</v-flex>
										</v-layout>
									</v-card>
								</v-flex>
								<v-flex xs12 class="text-xs-center">
									<v-btn @click="addWarehouse(selectedProduct.key)" color="primary" dark px-2>
										<v-icon left size="16px">add</v-icon>
										add a warehouseh
									</v-btn>
									<v-btn @click="saveWareHousesToProduct()" color="success" 
										v-if="selectedProduct.warehouse && selectedProduct.warehouse.length > 0" 
										dark 
										px-2>
										<v-icon left size="16px">save</v-icon>
										save warehousing
									</v-btn>
								</v-flex>
							</v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
							<!-- <v-btn @click="updateByKey()" :loading="loading" color="success" dark>
                update keys with values
              </v-btn> -->
              <v-btn color="primary" @click="updateProduct()">update product</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate} from '@/customFunction';
import axios from 'axios';
export default {
  data(){
    return {
			loading: false,
      products:[],
      syncing:false,
      selectedProduct:null,
      countries:[],
      warehouses:[],
      nwarehouse:{},
      selectedWarehouse:null,
      dialog: false,
      nName:null,
      nSKU:null,
      dialogAdd: false,
      dialogImport: false,
      pastedData:null,
      delimiter:null,
      importTotal:0,
      importDone:0,
    }
  },
  methods: {
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
		guessDelimiters (text, possibleDelimiters) {
			return possibleDelimiters.filter(weedOut);
			function weedOut (delimiter) {
				var cache = -1;
				return text.split('\n').every(checkLength);
				function checkLength (line) {
					if (!line) {
							return true;
					}
					var length = line.split(delimiter).length;
					if (cache < 0) {
							cache = length;
					}
					return cache === length && length > 1;
				}
			}
		},
		getArray(){
			let csv = this.pastedData
			let dels = [' ', '  ', ',', '	', '\t']
			this.delimiter = ','
			if(this.delimiter && this.delimiter > 1) {
				this.$emit('snackbarNotification', `Please export as CSV`, 'error')
				return
			}
			var lines=csv.split("\n");
      var result = [];
			var headers=lines[0].split(this.delimiter);
			for(var i=1;i<lines.length;i++){
					if (!lines[i])
							continue
					var obj = {};
					var currentline=lines[i].split(this.delimiter);
					for(var j=0;j<headers.length;j++){
							obj[headers[j]] = currentline[j];
					}
					result.push(obj);
			}
			return result
    },
    async importWarehouses(){
      let b = this.getArray()
      this.importTotal = b.length
      this.importDone = 0
      console.log('------------------------------------');
      console.log(b);
      console.log('------------------------------------');
      (async x=>{
        for (let i = 0; i < b.length; i++) {
          const item = b[i];
          let p = await store.collection(`products`).where('sku', '==', item.sku.trim()).get().then(x=>x.docs.map(y=>y.data())[0])
          if(p){
            let w = this.warehouses.map(x=>x.name)
            for (let k = 0; k < w.length; k++) {
              const wa = w[k];
              if(item[wa]){
                if(!p.warehouses) p.warehouses = []
                if(p.warehouses && !p.warehouses.map(x=>x.warehouse).includes(wa)) {
                  p.warehouses.push({
                    quantity:item[wa] && item[wa] != '' ? item[wa] : '0',
                    warehouse:wa
                  })
                } else if(p.warehouses && p.warehouses.map(x=>x.warehouse).includes(wa)){
                  let ind = p.warehouses.map(x=>x.warehouse).indexOf(wa)
                  p.warehouses[ind] = {
                    quantity:item[wa] && item[wa] != '' ? item[wa] : '0',
                    warehouse:wa
                  }
                }
              }
            }
            console.log(p)
            await store.collection('products').doc(p.key).update(p)
          } else {
            let product = {
              item_name:item.item_name,
              sku:item.sku,
            }
            let w = this.warehouses.map(x=>x.name)
            for (let k = 0; k < w.length; k++) {
              const wa = w[k];
              if(!product.warehouses) product.warehouses = []
              if(product.warehouses && !product.warehouses.map(x=>x.warehouse).includes(wa)) {
                product.warehouses.push({
                  quantity:item[wa] && item[wa] != '' ? item[wa] : '0',
                  warehouse:wa
                })
              }
            }
            product.key = x.key;
            await store.collection('products').doc(product.key).set(product)
          }
          this.importDone = i
        }
      })()
    },
    // async syncProducts() {
    //   this.syncing = true
    //   let a = await db.ref(`products`).once('value').then(x=>x.val())
    //   console.log(a)
    //   let k = Object.keys(a)
    //   let b = Object.values(a).map((x, i)=>{
    //     return {
    //       key:k[i],
    //       sku:x.sku,
    //       item_name:x.item_name,
    //     }
    //   }).filter(x=>x.key && x.sku && x.item_name)
    //   console.log(b);
    //   (async x=>{
    //     for (let i = 0; i < b.length; i++) {
    //       const p = b[i];
    //       let t = await store.collection('products').doc(p.key).get().then(x=>x.data())
    //       if(!t){
    //         await store.collection('products').doc(p.key).set(p)
    //         console.log(i);
    //       }
    //     }
    //     this.syncing = false
    //     this.getProducts()
    //   })()
    // },
    async getProducts(k){
      this.loading = true
      this.products = await store.collection('products').get()
      .then(x=>x.docs.map(y=>{
        return {
          ...y.data(),
          warehouses:y.data().warehouses? y.data().warehouses:[]
        }
      }))
      console.log(this.products)
      if(k){
        this.selectedProduct = this.products.filter(x=>x.key == k)[0]
      }
      this.loading = false
    },
    async warehouseAdd(){
      await store.collection('warehouses').add(this.nwarehouse)
      this.dialog = false
      this.getWarehouses()
    },
    async getWarehouses(){
      this.loading = true
      this.countries = await db.ref(`settings/dbfilters/countries`).once('value').then(x=>x.val().map(x=>x.toUpperCase()))
      this.warehouses = await store.collection('warehouses').get().then(x=>x.docs.map(y=>y.data()))
      console.log(this.warehouses)
      this.loading = false
    },
    removeWearhouse(k){
			this.selectedProduct.warehouses.splice(k, 1)
		},
		addWarehouse(key){
			console.log('a')
			this.selectedProduct.warehouses.push({
				warehouse:'',
				quantity:0,
			})
    },
    async updateProduct() {
      console.log(this.selectedProduct)
      await store.collection('products').doc(this.selectedProduct.key).update(this.selectedProduct)
      this.getProducts(this.selectedProduct.key)
      this.loadWarehouseProducts()
    },
    loadWarehouseProducts(){
      if(this.selectedWarehouse) {
        let a  = this.products.filter(x=>x.warehouses && x.warehouses.map(x=>x.warehouse).includes(this.selectedWarehouse.name))
        this.selectedWarehouse.products = a
        console.log(a)
			  this.$emit('snackbarNotification', `${this.selectedWarehouse.name} is loaded`, 'success')
      }
    },
    // async addProduct(){
		// 	let product = {
		// 		item_name:this.nName,
		// 		sku:this.nSKU,
		// 	}
		// 	let x = await db.ref(`products`)
		// 	.push(product);
    //   product.key = x.key;
    //   product.warehouses = []
		// 	await store.collection('products').doc(product.key).set(product)
		// 	await store.collection('productsLive').doc(product.key).set(product)
		// 	this.products.push(product);
		// 	this.dialogAdd = false
		// 	this.selectedProduct = product;
		// 	this.$emit('snackbarNotification', `${product.item_name} is added`, 'success')

    // },
    convertToCSV(arr) {
      const array = [Object.keys(arr[0])].concat(arr)

      return array.map(it => {
        return Object.values(it).toString()
      }).join('\n')
    },
    exportWarehouseh(){
      let a = this.convertToCSV(this.selectedWarehouse.products.map(x=>{
        return {
          item_name:x.item_name,
          sku:x.sku,
          quantity:x.warehouses.filter(x=>x.warehouse==this.selectedWarehouse.name)[0].quantity
        }
      }))
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri = encodeURI(csvContent + a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `${this.selectedWarehouse.name}_report.csv`);
      document.body.appendChild(link); // Required for FF

      link.click();
    }
  },
  props:{
		superAdmin:{
			required:true
		},
		userName:{
			default:null
    },
    userRole: {
      required: true,
      default: 'user'
    },
    beta: {
      required: true,
      default: false
    },
    superAdmin: {
      required: true,
      default: false
    },
    warehouse:{}
  },
  computed:{
    
  },
  async created(){
    this.getProducts()
    this.getWarehouses()
  }
}
</script>

<style>
.tokenField * {
  color:white !important;
}
</style>
